import React, { useEffect, useState } from 'react';
import electronics from '../../images/icons/electronics.svg'
import heroright from '../../images/heroright.svg'
import CustomCarousel from '../../components/carousel';
import Card from '../../components/Card';
import appstore from '../../images/appstore.svg'
import googleplay from '../../images/googleplay.svg'
import phones from '../../images/phones.svg'
import Advert from '../../components/advert';
import axios from 'axios'
import { ColorRing } from 'react-loader-spinner'

function HomeBody(props) {
    const [categories, setCategories] = useState([
    ])

    const [cards, setCards] = useState([

    ])

    const navigateToCategory = (category) => {
        sessionStorage.setItem('categoryId',category.id)
        sessionStorage.setItem('currentCategory',category.categoryName)
        window.location.href='/businesses'
    }

    let [fetched, setFetched] = useState()
    useEffect(() => {
        axios.get(process.env.REACT_APP_BASE_URL+'/Category/GetTopLevel',{})
        .then((res) => {
            if(res.status == 200){
                setCategories(res.data.data)
            }}
        ).then(() => {
            let url = sessionStorage.getItem('searchQuery') ? '/search?query='+sessionStorage.getItem('searchQuery') : '/Business/RecentAdditions/100/1'
            axios.get(process.env.REACT_APP_BASE_URL+url,{})
            .then((res2) => {
                if(res2.status == 200){
                    console.log(res2.data.data)
                    setCards(sessionStorage.getItem('searchQuery') ? res2.data.data : res2.data.data.items)
                    setFetched(1)
                }
                })
            .then(() => {
                sessionStorage.setItem('searchQuery','')
            })
        })
        .catch((e) => {
            console.log(e)
        })
    }, [])

    const [searchQuery, setSearchchQuery] = useState()
    const makeSearch = (e) => {
        e.preventDefault()
        sessionStorage.setItem('searchQuery',searchQuery)
        window.location.href=''
    }

    return (
        <div className='p-5 lg:p-20 lg:pt-10'>
            <div className="bg-[url('images/HomeHero.svg')] bg-no-repeat grid grid-cols-8 text-white py-7 px-5 rounded-[16px] space-y-3">
                <div className='col-span-8 lg:col-span-5 text-start flex flex-col space-y-3'>  
                    <span className='font-[700] lg:leading-[70.4px] text-[24px] lg:text-[64px] text-start'>Get the Positive Recommendations Your Business Deserves</span>
                    <span>Build your reputation, attract more clients, and watch your business thrive with recommendations.</span>
                    <form className='relative' onSubmit={makeSearch}>
                        <input onChange={(e) => setSearchchQuery(e.target.value)} className='relative bg-white rounded-[32px] w-full lg:w-[70%] h-[50px] p-3 outline-none text-black' placeholder='Search business name'/>
                        <button type='submit' className='absolute bg-[#008B39] rounded-[30px] left-[58%] lg:left-[52%] top-[5px] px-8 p-2'>Search</button>
                    </form>
                </div>
                <div className='col-span-8 lg:col-span-3'>
                    <img className='h-[350px] w-full lg:w-[100%]' src={heroright} />
                </div>
            </div>

            <div className="w-full flex items-center space-x-4 overflow-x-auto scrollbar-hide my-5 lg:my-20">
                {categories.map((category, index) => (
                    <div
                    key={index}
                    onClick={() => navigateToCategory(category)}
                    className="flex cursor-pointer flex-row items-center justify-start px-3 space-x-3 w-48 h-20 bg-[#F8F8F8] rounded-[6px] flex-shrink-0"
                    >
                    <div className="text-3xl"><img className='h-10 w-10' src={category.image.originalUrl}/></div>
                    <p className="text-sm font-medium">{category? category.categoryName: ''}</p>
                    </div>
                ))}
            </div>
   
            <div className=''>
                {fetched ? 
                    cards.length > 0 ? 
                    <CustomCarousel
                    defaultItemsPerSlide={3}
                    defaultRows={3}
                    responsive={[
                        { breakpoint: 1024, itemsPerSlide: 1, rows: 2 },
                        { breakpoint: 768, itemsPerSlide: 2, rows: 2 },
                        { breakpoint: 480, itemsPerSlide: 2, rows: 3 },
                    ]}
                    >
                        {cards.map((item, index) => (
                            <Card key={index} className="" {...item}></Card>
                        ))}
                    </CustomCarousel> : <div className='font-semibold text-[20px]'>No results fetched, please check your internet or refresh.</div>
                :
                <div className='items-center grid mx-auto w-[80px] h-[80px] text-center'>
                <ColorRing
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="color-ring-loading"
                    wrapperStyle={{}}
                    wrapperClass="color-ring-wrapper"
                    colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
                    className="mx-auto"
                    />
                </div>

                }
            </div>

            <div className='pb-10 lg:pb-20 pt-10 lg:pt-20'>
                <div className="relative w-full h-0" style={{ paddingBottom: '56.25%' }}>
                    <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src="https://www.youtube.com/embed/LtgUaxGIrc8"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    ></iframe>
                </div>
            </div>
            {/* <div className=' mt-5 lg:mt-20'>
                <Advert></Advert>
            </div>   */}
        </div>
    );
}

export default HomeBody;